import { RichText } from "components/RichTextWidget";
import { buildWidgetInstanceId } from "features/widgets";
import { Container, Heading3, LazyRenderingButton } from "shared/components";
import { LazyRenderingProvider } from "shared/components/LazyRenderingButton";
import { useCollectedData } from "shared/contexts/PageData";

import styles from "./Content067.module.scss";
import { Items } from "./Items";

export const Content067 = ({ payload }) => {
  const instanceId = buildWidgetInstanceId("067", payload.id);
  const { events } = useCollectedData(instanceId, [
    { name: "events", defaultValue: [] },
  ]);

  const title = payload?.title ?? "";
  const description = payload?.caption ?? "";
  const buttonText = payload?.buttonText ?? "";

  if (events.length < 1) {
    return null;
  }
  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.top}>
          <Heading3 className={styles.title}>{title}</Heading3>
          <RichText value={description} className={styles.description} />
        </div>
        <div className={styles.content}>
          <LazyRenderingProvider
            size={events.length}
            initialLimit={2}
            incrementBy={2}
          >
            <Items items={events} />

            <LazyRenderingButton appearance="grey" buttonText={buttonText} />
          </LazyRenderingProvider>
        </div>
      </Container>
    </div>
  );
};

export default Content067;
